/* eslint-disable react/no-unescaped-entities */
import React from 'react';

import { Box, Image } from '@chakra-ui/react';

import MSTeamsPlugin from 'assets/assetsV1/illustrations/MSTeamsPlugin.png';

import { TextBodyMedium, TextLabel } from 'uiToolkitV1/Typography';

import { NumberIconSteps, StepCard } from '../commonComponents';

const InstallationSection = () => (
  <StepCard
    title="Installation Steps"
    rightComp={
      <Box
        border="1px solid"
        borderColor="feedback.D6E7F9"
        borderRadius="8px"
        overflow="hidden"
        width="45%"
        pt={5}
        pl={5}
        bg="#F1FBFF"
      >
        <Image src={MSTeamsPlugin} objectFit="cover" width="100%" height="100%" />
      </Box>
    }
  >
    <Box>
      <TextLabel bold mb={3}>
        Approach 1:
      </TextLabel>

      <NumberIconSteps
        stepsComps={[
          <TextBodyMedium>
            Click the <b>"Install"</b> button above. A popup will open in MS Teams.
          </TextBodyMedium>,

          <TextBodyMedium>
            Click on <b>"Add"</b> to add in your workspace.
          </TextBodyMedium>,
        ]}
      />
    </Box>

    <Box>
      <TextLabel bold mb={3}>
        Approach 2 (Alternative):
      </TextLabel>

      <NumberIconSteps
        stepsComps={[
          <TextBodyMedium>
            Open MS Teams, <b>"Click"</b> on Apps on the bottom left.
          </TextBodyMedium>,

          <TextBodyMedium>
            Search for <b>"Mesh"</b> using search box and click on <b>"Mesh"</b> app.
          </TextBodyMedium>,

          <TextBodyMedium>
            <b>"Click on Add"</b> to be able to use the personal tabs.
          </TextBodyMedium>,
        ]}
      />
    </Box>
  </StepCard>
);

export { InstallationSection };
